// extracted by mini-css-extract-plugin
export var chevron = "_bd-2";
export var dropdownItems = "_bd-0";
export var item = "_bd-1";